import m2Sidebar from "@components/sidebar/m2_sidebar";
import phoneBox from "@components/safeProblem/bundingPhone.vue";
import emailBox from "@components/safeProblem/bundingEmail.vue";
import changePwd from "@components/safeProblem/changePwd.vue";
export default {
  data() {
    return {
      Phone_box: false,
      Email_box: false,
      Change_pwd: false,
      Account: {}
    };
  },
  //弹窗组件
  components: {
    phoneBox: phoneBox,
    emailBox: emailBox,
    changePwd: changePwd,
    m2Sidebar: m2Sidebar
  },
  created: function() {
    this.getAllAccount();
    this.$store.commit("setHeaderState", "0");
  },
  //自定义在实例
  filters: {
    phoneHide: function(value) {
      let re = /([\s\S]{3})([\s\S]{4})/;
      if (value != undefined) return value.replace(re, "$1****");
      else return value;
    },
    emailHide: function(value) {
      let re = /([\s\S]{2})([\s\S]{4})/;
      if (value != undefined) return value.replace(re, "$1****");
      else return value;
    }
  },
  methods: {
    onPhoneChange(val) {
      this.Phone_box = val;
      this.getAllAccount();
    },
    onEmailChange(val) {
      this.Email_box = val;
      this.getAllAccount();
    },
    onChangePwd(val) {
      this.Change_pwd = val;
      this.getAllAccount();
    },
    getAllAccount: function() {
      this.$http.get(globalProvider.serviceUrl("ea/g/acs")).then(data => {
        if (data.body.code == resultCode.Success) {
          this.Account = data.body.data;
        }
      });
    }
  }
};